import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _classPrivateFieldSet from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
var _initialState, _revertState, _cache, _client, _retryer, _defaultOptions, _abortSignalConsumed, _dispatch;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
// src/query.ts
import { ensureQueryFn, noop, replaceData, resolveEnabled, skipToken, timeUntilStale } from "./utils.js";
import { notifyManager } from "./notifyManager.js";
import { canFetch, createRetryer, isCancelledError } from "./retryer.js";
import { Removable } from "./removable.js";
var Query = (_initialState = /*#__PURE__*/new WeakMap(), _revertState = /*#__PURE__*/new WeakMap(), _cache = /*#__PURE__*/new WeakMap(), _client = /*#__PURE__*/new WeakMap(), _retryer = /*#__PURE__*/new WeakMap(), _defaultOptions = /*#__PURE__*/new WeakMap(), _abortSignalConsumed = /*#__PURE__*/new WeakMap(), _dispatch = /*#__PURE__*/new WeakSet(), class Query extends Removable {
  constructor(config) {
    var _config$state;
    super();
    _classPrivateMethodInitSpec(this, _dispatch);
    _classPrivateFieldInitSpec(this, _initialState, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _revertState, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _cache, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _client, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _retryer, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _defaultOptions, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _abortSignalConsumed, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldSet(this, _abortSignalConsumed, false);
    _classPrivateFieldSet(this, _defaultOptions, config.defaultOptions);
    this.setOptions(config.options);
    this.observers = [];
    _classPrivateFieldSet(this, _client, config.client);
    _classPrivateFieldSet(this, _cache, _classPrivateFieldGet(this, _client).getQueryCache());
    this.queryKey = config.queryKey;
    this.queryHash = config.queryHash;
    _classPrivateFieldSet(this, _initialState, getDefaultState(this.options));
    this.state = (_config$state = config.state) !== null && _config$state !== void 0 ? _config$state : _classPrivateFieldGet(this, _initialState);
    this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  get promise() {
    var _classPrivateFieldGet2;
    return (_classPrivateFieldGet2 = _classPrivateFieldGet(this, _retryer)) === null || _classPrivateFieldGet2 === void 0 ? void 0 : _classPrivateFieldGet2.promise;
  }
  setOptions(options) {
    this.options = _objectSpread(_objectSpread({}, _classPrivateFieldGet(this, _defaultOptions)), options);
    this.updateGcTime(this.options.gcTime);
  }
  optionalRemove() {
    if (!this.observers.length && this.state.fetchStatus === "idle") {
      _classPrivateFieldGet(this, _cache).remove(this);
    }
  }
  setData(newData, options) {
    const data = replaceData(this.state.data, newData, this.options);
    _classPrivateMethodGet(this, _dispatch, _dispatch2).call(this, {
      data,
      type: "success",
      dataUpdatedAt: options === null || options === void 0 ? void 0 : options.updatedAt,
      manual: options === null || options === void 0 ? void 0 : options.manual
    });
    return data;
  }
  setState(state, setStateOptions) {
    _classPrivateMethodGet(this, _dispatch, _dispatch2).call(this, {
      type: "setState",
      state,
      setStateOptions
    });
  }
  cancel(options) {
    var _classPrivateFieldGet3, _classPrivateFieldGet4;
    const promise = (_classPrivateFieldGet3 = _classPrivateFieldGet(this, _retryer)) === null || _classPrivateFieldGet3 === void 0 ? void 0 : _classPrivateFieldGet3.promise;
    (_classPrivateFieldGet4 = _classPrivateFieldGet(this, _retryer)) === null || _classPrivateFieldGet4 === void 0 || _classPrivateFieldGet4.cancel(options);
    return promise ? promise.then(noop).catch(noop) : Promise.resolve();
  }
  destroy() {
    super.destroy();
    this.cancel({
      silent: true
    });
  }
  reset() {
    this.destroy();
    this.setState(_classPrivateFieldGet(this, _initialState));
  }
  isActive() {
    return this.observers.some(observer => resolveEnabled(observer.options.enabled, this) !== false);
  }
  isDisabled() {
    if (this.getObserversCount() > 0) {
      return !this.isActive();
    }
    return this.options.queryFn === skipToken || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
  }
  isStale() {
    if (this.state.isInvalidated) {
      return true;
    }
    if (this.getObserversCount() > 0) {
      return this.observers.some(observer => observer.getCurrentResult().isStale);
    }
    return this.state.data === void 0;
  }
  isStaleByTime() {
    let staleTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return this.state.isInvalidated || this.state.data === void 0 || !timeUntilStale(this.state.dataUpdatedAt, staleTime);
  }
  onFocus() {
    var _classPrivateFieldGet5;
    const observer = this.observers.find(x => x.shouldFetchOnWindowFocus());
    observer === null || observer === void 0 || observer.refetch({
      cancelRefetch: false
    });
    (_classPrivateFieldGet5 = _classPrivateFieldGet(this, _retryer)) === null || _classPrivateFieldGet5 === void 0 || _classPrivateFieldGet5.continue();
  }
  onOnline() {
    var _classPrivateFieldGet6;
    const observer = this.observers.find(x => x.shouldFetchOnReconnect());
    observer === null || observer === void 0 || observer.refetch({
      cancelRefetch: false
    });
    (_classPrivateFieldGet6 = _classPrivateFieldGet(this, _retryer)) === null || _classPrivateFieldGet6 === void 0 || _classPrivateFieldGet6.continue();
  }
  addObserver(observer) {
    if (!this.observers.includes(observer)) {
      this.observers.push(observer);
      this.clearGcTimeout();
      _classPrivateFieldGet(this, _cache).notify({
        type: "observerAdded",
        query: this,
        observer
      });
    }
  }
  removeObserver(observer) {
    if (this.observers.includes(observer)) {
      this.observers = this.observers.filter(x => x !== observer);
      if (!this.observers.length) {
        if (_classPrivateFieldGet(this, _retryer)) {
          if (_classPrivateFieldGet(this, _abortSignalConsumed)) {
            _classPrivateFieldGet(this, _retryer).cancel({
              revert: true
            });
          } else {
            _classPrivateFieldGet(this, _retryer).cancelRetry();
          }
        }
        this.scheduleGc();
      }
      _classPrivateFieldGet(this, _cache).notify({
        type: "observerRemoved",
        query: this,
        observer
      });
    }
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    if (!this.state.isInvalidated) {
      _classPrivateMethodGet(this, _dispatch, _dispatch2).call(this, {
        type: "invalidate"
      });
    }
  }
  fetch(options, fetchOptions) {
    var _this$options$behavio, _context$fetchOptions;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.data !== void 0 && fetchOptions !== null && fetchOptions !== void 0 && fetchOptions.cancelRefetch) {
        this.cancel({
          silent: true
        });
      } else if (_classPrivateFieldGet(this, _retryer)) {
        _classPrivateFieldGet(this, _retryer).continueRetry();
        return _classPrivateFieldGet(this, _retryer).promise;
      }
    }
    if (options) {
      this.setOptions(options);
    }
    if (!this.options.queryFn) {
      const observer = this.observers.find(x => x.options.queryFn);
      if (observer) {
        this.setOptions(observer.options);
      }
    }
    if (process.env.NODE_ENV !== "production") {
      if (!Array.isArray(this.options.queryKey)) {
        console.error("As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']");
      }
    }
    const abortController = new AbortController();
    const addSignalProperty = object => {
      Object.defineProperty(object, "signal", {
        enumerable: true,
        get: () => {
          _classPrivateFieldSet(this, _abortSignalConsumed, true);
          return abortController.signal;
        }
      });
    };
    const fetchFn = () => {
      const queryFn = ensureQueryFn(this.options, fetchOptions);
      const queryFnContext = {
        client: _classPrivateFieldGet(this, _client),
        queryKey: this.queryKey,
        meta: this.meta
      };
      addSignalProperty(queryFnContext);
      _classPrivateFieldSet(this, _abortSignalConsumed, false);
      if (this.options.persister) {
        return this.options.persister(queryFn, queryFnContext, this);
      }
      return queryFn(queryFnContext);
    };
    const context = {
      fetchOptions,
      options: this.options,
      queryKey: this.queryKey,
      client: _classPrivateFieldGet(this, _client),
      state: this.state,
      fetchFn
    };
    addSignalProperty(context);
    (_this$options$behavio = this.options.behavior) === null || _this$options$behavio === void 0 || _this$options$behavio.onFetch(context, this);
    _classPrivateFieldSet(this, _revertState, this.state);
    if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) === null || _context$fetchOptions === void 0 ? void 0 : _context$fetchOptions.meta)) {
      var _context$fetchOptions2;
      _classPrivateMethodGet(this, _dispatch, _dispatch2).call(this, {
        type: "fetch",
        meta: (_context$fetchOptions2 = context.fetchOptions) === null || _context$fetchOptions2 === void 0 ? void 0 : _context$fetchOptions2.meta
      });
    }
    const onError = error => {
      if (!(isCancelledError(error) && error.silent)) {
        _classPrivateMethodGet(this, _dispatch, _dispatch2).call(this, {
          type: "error",
          error
        });
      }
      if (!isCancelledError(error)) {
        var _classPrivateFieldGet7, _classPrivateFieldGet8, _classPrivateFieldGet9, _classPrivateFieldGet10;
        (_classPrivateFieldGet7 = (_classPrivateFieldGet8 = _classPrivateFieldGet(this, _cache).config).onError) === null || _classPrivateFieldGet7 === void 0 || _classPrivateFieldGet7.call(_classPrivateFieldGet8, error, this);
        (_classPrivateFieldGet9 = (_classPrivateFieldGet10 = _classPrivateFieldGet(this, _cache).config).onSettled) === null || _classPrivateFieldGet9 === void 0 || _classPrivateFieldGet9.call(_classPrivateFieldGet10, this.state.data, error, this);
      }
      this.scheduleGc();
    };
    _classPrivateFieldSet(this, _retryer, createRetryer({
      initialPromise: fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.initialPromise,
      fn: context.fetchFn,
      abort: abortController.abort.bind(abortController),
      onSuccess: data => {
        var _classPrivateFieldGet11, _classPrivateFieldGet12, _classPrivateFieldGet13, _classPrivateFieldGet14;
        if (data === void 0) {
          if (process.env.NODE_ENV !== "production") {
            console.error("Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: ".concat(this.queryHash));
          }
          onError(new Error("".concat(this.queryHash, " data is undefined")));
          return;
        }
        try {
          this.setData(data);
        } catch (error) {
          onError(error);
          return;
        }
        (_classPrivateFieldGet11 = (_classPrivateFieldGet12 = _classPrivateFieldGet(this, _cache).config).onSuccess) === null || _classPrivateFieldGet11 === void 0 || _classPrivateFieldGet11.call(_classPrivateFieldGet12, data, this);
        (_classPrivateFieldGet13 = (_classPrivateFieldGet14 = _classPrivateFieldGet(this, _cache).config).onSettled) === null || _classPrivateFieldGet13 === void 0 || _classPrivateFieldGet13.call(_classPrivateFieldGet14, data, this.state.error, this);
        this.scheduleGc();
      },
      onError,
      onFail: (failureCount, error) => {
        _classPrivateMethodGet(this, _dispatch, _dispatch2).call(this, {
          type: "failed",
          failureCount,
          error
        });
      },
      onPause: () => {
        _classPrivateMethodGet(this, _dispatch, _dispatch2).call(this, {
          type: "pause"
        });
      },
      onContinue: () => {
        _classPrivateMethodGet(this, _dispatch, _dispatch2).call(this, {
          type: "continue"
        });
      },
      retry: context.options.retry,
      retryDelay: context.options.retryDelay,
      networkMode: context.options.networkMode,
      canRun: () => true
    }));
    return _classPrivateFieldGet(this, _retryer).start();
  }
});
function _dispatch2(action) {
  const reducer = state => {
    var _action$meta, _action$dataUpdatedAt;
    switch (action.type) {
      case "failed":
        return _objectSpread(_objectSpread({}, state), {}, {
          fetchFailureCount: action.failureCount,
          fetchFailureReason: action.error
        });
      case "pause":
        return _objectSpread(_objectSpread({}, state), {}, {
          fetchStatus: "paused"
        });
      case "continue":
        return _objectSpread(_objectSpread({}, state), {}, {
          fetchStatus: "fetching"
        });
      case "fetch":
        return _objectSpread(_objectSpread(_objectSpread({}, state), fetchState(state.data, this.options)), {}, {
          fetchMeta: (_action$meta = action.meta) !== null && _action$meta !== void 0 ? _action$meta : null
        });
      case "success":
        return _objectSpread(_objectSpread({}, state), {}, {
          data: action.data,
          dataUpdateCount: state.dataUpdateCount + 1,
          dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) !== null && _action$dataUpdatedAt !== void 0 ? _action$dataUpdatedAt : Date.now(),
          error: null,
          isInvalidated: false,
          status: "success"
        }, !action.manual && {
          fetchStatus: "idle",
          fetchFailureCount: 0,
          fetchFailureReason: null
        });
      case "error":
        const error = action.error;
        if (isCancelledError(error) && error.revert && _classPrivateFieldGet(this, _revertState)) {
          return _objectSpread(_objectSpread({}, _classPrivateFieldGet(this, _revertState)), {}, {
            fetchStatus: "idle"
          });
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          error,
          errorUpdateCount: state.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: state.fetchFailureCount + 1,
          fetchFailureReason: error,
          fetchStatus: "idle",
          status: "error"
        });
      case "invalidate":
        return _objectSpread(_objectSpread({}, state), {}, {
          isInvalidated: true
        });
      case "setState":
        return _objectSpread(_objectSpread({}, state), action.state);
    }
  };
  this.state = reducer(this.state);
  notifyManager.batch(() => {
    this.observers.forEach(observer => {
      observer.onQueryUpdate();
    });
    _classPrivateFieldGet(this, _cache).notify({
      query: this,
      type: "updated",
      action
    });
  });
}
function fetchState(data, options) {
  return _objectSpread({
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchStatus: canFetch(options.networkMode) ? "fetching" : "paused"
  }, data === void 0 && {
    error: null,
    status: "pending"
  });
}
function getDefaultState(options) {
  const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
  const hasData = data !== void 0;
  const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
  return {
    data,
    dataUpdateCount: 0,
    dataUpdatedAt: hasData ? initialDataUpdatedAt !== null && initialDataUpdatedAt !== void 0 ? initialDataUpdatedAt : Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: false,
    status: hasData ? "success" : "pending",
    fetchStatus: "idle"
  };
}
export { Query, fetchState };